import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 0H6V6H0V8H6V14H8V8H14V6H8V0Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
